import api from "@/lib/api";

const KEYS = ["src", "utm_source", "utm_medium", "utm_campaign", "utm_content"];

export const getSource = () => {
  const stored = sessionStorage.getItem("c2c_source");
  if (stored) return JSON.parse(stored);
  const p = new URLSearchParams(window.location.search);
  const src = Object.fromEntries(KEYS.filter((k) => p.get(k)).map((k) => [k, p.get(k)]));
  const ref = document.referrer && !document.referrer.startsWith(window.location.origin) ? document.referrer : "";
  if (ref) src.referrer = ref;
  sessionStorage.setItem("c2c_source", JSON.stringify(src));
  return src;
};

const sessionId = () => {
  let id = sessionStorage.getItem("c2c_sid");
  if (!id) {
    id = `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 10)}`;
    sessionStorage.setItem("c2c_sid", id);
  }
  return id;
};

export const trackFunnel = (segment, type) =>
  api.post(`/funnel/${segment}/event`, { type, session_id: sessionId(), source: getSource() }).catch(() => {});
